module.exports = __webpack_public_path__ + "static/img/IMG_20241030_171056.c088a2c1.jpg";